module.exports = __webpack_public_path__ + "img/20240710105444988j6i.e6f9bbe1.jpg";